module.exports = __webpack_public_path__ + "img/purchase-curriculum.c1017bd6.jpg";